import React, { Component } from 'react';
import { Loader } from './index';
import styled from 'styled-components';

import facebookIcon from '../../assets/images/facebook-icon.png';
import instagramIcon from '../../assets/images/instagram-icon.png';
import iMessageIcon from '../../assets/images/imessage-icon.png';

type Props = {
  image: any,
  description: string,
  source: string,
  link: string,
  subStr: Function
};

type State = {
  loading: boolean
};

const IMessage = styled.div`
  margin-right: 30px;
  min-width: 250px;
`;
const IMessageData = styled.div`padding: 6px 20px !important;`;
const Container = styled.a`
  float: left;
  max-width: 250px;
  position: relative;
  border-radius: 10px;
  background-color: #e4e5e9;
  margin: 5px 0;
  text-decoration: none;
  ::before {
    content: "";
    position: absolute;
    z-index: 0;
    bottom: -2px;
    right: -7px;
    height: 20px;
    border-right: 20px solid #e5e5ea;
    border-bottom-left-radius: 16px 14px;
    -webkit-transform: translate(0, -2px);
  }
  ::after {
    content: "";
    position: absolute;
    z-index: 1;
    bottom: -2px;
    right: -56px;
    width: 26px;
    height: 20px;
    background: #ffffff;
    border-bottom-left-radius: 10px;
    -webkit-transform: translate(-30px, -2px);
  }
`;
const Image = styled.img`
  max-width: 250px;
  -webkit-border-top-left-radius: 10px;
  -webkit-border-top-right-radius: 10px;
  -moz-border-radius-topleft: 10px;
  -moz-border-radius-topright: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const Link = styled.p`
  color: #aaa;
  font-size: 14px;
  margin: 0;
  text-align: left;
`;

const Description = styled.p`
  color: #111;
  font-size: 14px;
  margin: 0 0 1px 0;
  text-align: left;
  font-weight: bold;
`;
const LogosContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;
const Logo = styled.img`height: 24px;`;
const Sum = styled.span`
  font-size: 24px;
  color: #aaa;
  margin: 0 10px;
  font-weight: bold;
`;

class IMessageComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 2500);
  }

  renderContent = () => {
    const { image, description, source, link, subStr } = this.props;

    if (this.state.loading) {
      return <Loader inverted active />;
    }

    return (
      <Container href={link} target="_blank">
        <Image src={image} alt={description} />
        <IMessageData className="iMessage-data">
          <Description>{subStr(description, 76)}</Description>
          <Link>{source}</Link>
        </IMessageData>
      </Container>
    );
  };

  renderSource = () => {
    if (this.props.facebook) {
      return <Logo src={facebookIcon} alt="Facebook" />;
    }

    return <Logo src={instagramIcon} alt="Instagram" />;
  };

  render() {
    return (
      <div>
        <h4 className="preview-title">iMessage</h4>
        <LogosContainer>
          {this.renderSource()}
          <Sum>+</Sum>
          <Logo src={iMessageIcon} alt="iMessage" />
        </LogosContainer>

        <IMessage className="preview-container">
          {this.renderContent()}
          <div className="clearfix" />
        </IMessage>
      </div>
    );
  }
}

export default IMessageComponent;



// WEBPACK FOOTER //
// ./src/components/share/IMessage.js